import classNames from "classnames";
import * as React from "react";

interface ITrasnferTrackerProps {
    cssWrapper?: string;
    secondStep?: boolean;
    complete?: boolean;
}

export const TransferTracker = (props: ITrasnferTrackerProps) => {
    const className = classNames("transfer-tracker", props.cssWrapper);

    return (
        <div className={className}>
            <ul className="mb-30">
                <li className="active step-1">
                    <div className="step">1</div>
                </li>
                <li className={props.secondStep || props.complete ? "active step-2" : "step-2"}>
                    <div className="step">2</div>
                </li>
                <li className={props.complete ? "active step-3" : "step-3"}>
                    <div className="step">3</div>
                </li>
            </ul>
            <div className="row no-gutter">
                <div className="col-4">
                    <div className="label">Pending review of transfer application</div>
                </div>
                <div className="col-4">
                    <div className="label text-center">Transfer request by abrdn</div>
                </div>
                <div className="col-4">
                    <div className="label text-right">Transfer received</div>
                </div>
            </div>
        </div>
    );
};
